module.exports = __webpack_public_path__ + "static/media/linkedinlogo.529fc1c0.svg";